var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 234,
    viewBox: "0 0 513 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M487.188 233.059L466.513 233.059L466.513 207.184L487.125 207.184L487.125 186.51L466.45 186.51L466.45 207.184L440.576 207.184L440.576 186.51L394.027 186.51L394.027 160.635L373.353 160.635L373.353 186.51L347.478 186.51L347.478 160.635L326.866 160.635L326.866 139.961L347.541 139.961L347.541 160.635L373.353 160.635L373.353 139.961L466.45 139.961L466.45 114.086L487.125 114.086L487.125 139.961L513 139.961L513 207.184L487.188 207.184L487.188 233.059Z",
    fill: "#61DFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300.991 139.961L280.317 139.961L280.317 114.086L233.767 114.086L233.767 93.4112L280.317 93.4112L280.317 114.086L300.991 114.086L300.991 139.961Z",
    fill: "#61DFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.968 93.0979L207.643 93.0979L207.643 67.2233L186.968 67.2233L186.968 93.0979Z",
    fill: "#61DFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5085 20.6743L68.1831 20.6743L68.1831 -5.41459e-05L47.5085 -5.59533e-05L47.5085 20.6743Z",
    fill: "#61DFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.960285 20.6743L21.6344 20.6743L21.6344 -5.82153e-05L0.960286 -6.00227e-05L0.960285 20.6743Z",
    fill: "#61DFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroOverlay);
export default __webpack_public_path__ + "static/media/hero-overlay.fdfcc0b2781360143bfc61be39f1a5ed.svg";
export { ForwardRef as ReactComponent };